export const DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_NOTIFICATION_ID =
  'splittingArea'

export const DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_FOUND_NOTIFICATION_ID =
  'splittingAreaFound'

export const DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_FOUND_ERROR_NOTIFICATION_ID =
  'splittingAreaFoundError'

export const DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_NOT_CHANGED_ERROR_NOTIFICATION_ID =
  'splittingAreaNotChangedError'

export const DOC_FLOW_MAPPING_WIDGET_SPLITTING_AREA_TEST_IN_PROCESS_NOTIFICATION_ID =
  'splittingAreaTestInProcess'

export const DOC_FLOW_MAPPING_WIDGET_SPLITTING_NOTIFICATION_ID_SERVER_ERROR =
  'splittingServerError'
